import { graphql } from '@/generated/gql';

export const SAVE_FILTER_MUTATION = graphql(/* GraphQL */ `
  mutation SaveFilter($id: uuid, $name: String, $queryId: uuid, $domain: String, $isFavorite: Boolean) {
    insert_filters_one(
      object: { id: $id, name: $name, queryId: $queryId, domain: $domain, isFavorite: $isFavorite }
      on_conflict: { constraint: filters_pkey, update_columns: [name, queryId] }
    ) {
      id
      userId
      name
      queryId
      domain
      isFavorite
    }
  }
`);
